<template>
  <div class="h-[4px] w-full overflow-hidden rounded-full border bg-slate-200">
    <div class="h-[4px] rounded-r-xl bg-light-green transition-all" :style="{ width: value + '%' }"></div>
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Number,
    default: 0
  }
})
</script>
